// extracted by mini-css-extract-plugin
export var content = "_d1-3";
export var list = "_d1-4";
export var settingsContent = "_d1-7";
export var settingsPanel = "_d1-8";
export var state = "_d1-6";
export var triggerBadge = "_d1-2";
export var triggerButton = "_d1-1";
export var triggerShell = "_d1-0";
export var unreadDot = "_d1-5";